export const brands = [
    {
        id: 1,
        image: "/images/brands/brand1.png",
    },
    {
        id: 2,
        image: "/images/brands/brand3.png",
    },
    {
        id: 3,
        image: "/images/brands/brand4.png",
    },
    {
        id: 4,
        image: "/images/brands/brand5.jpg",
    },
]